<template>
  <div>
    <div class="footerLinks-item-title">公式アプリ</div>
    <p class="footerLinks-item-text">全国各地の街コン・パーティーを簡単に探せます！</p>
    <ul class="clMobileApps-appList">
      <li class="clMobileApps-appList-item marginR3">
        <a href="/app-download?sp_banner=app_download">
          <common-lazy-load-image
            :image-url="appstoreBadge"
            :image-object="{ width: 135, height: 40 }"
            :is-fixed-dimension="true"
            alt="Storeからダウンロード"
            background-color="none"
          />
        </a>
      </li>
      <li class="clMobileApps-appList-item">
        <a href="/app-download?sp_banner=app_download">
          <common-lazy-load-image
            :image-url="googleplayBadge"
            :image-object="{ width: 135, height: 40 }"
            :is-fixed-dimension="true"
            alt="Playで手に入れよう"
            background-color="none"
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { CACHE_COUPLINK_MOBILE_APP } from '@/utils/constants/serverCaching'
const CommonLazyLoadImage = defineAsyncComponent(() => import('@/components/CommonLazyLoadImage.vue'))
import appstoreBadge from '/assets/images/svg/appstore_badge.svg'
import googleplayBadge from '/assets/images/svg/googleplay_badge.png'
export default {
  name: CACHE_COUPLINK_MOBILE_APP.name,
  components: { CommonLazyLoadImage },
  serverCacheKey() {
    return Math.floor(Date.now() / CACHE_COUPLINK_MOBILE_APP.time)
  },
  props: {
    displayBorderBg: { type: Boolean, default: true, required: false }
  },
  data() {
    return {
      appstoreBadge,
      googleplayBadge
    }
  }
}
</script>

<style lang="scss" scoped>
.clMobileApps {
  &-appList {
    @include flex;
    justify-content: left;
    &-item {
      width: 100%;
      max-width: 135px;
      height: auto;
    }
  }
}

.footerLinks {
  &-item {
    &-title {
      font-size: 1.8rem;
      font-weight: bold;
      color: $white;
      margin-bottom: 1rem;
    }
    &-text {
      font-size: 1.2rem;
      margin-bottom: 1.6rem;
      @include sp {
        display: inline-block;
        width: 100%;
      }
    }
  }
}

:deep() {
  .fixedDimension {
    object-fit: contain;
  }
}
</style>
